import React from 'react';
import {
  Text,
  Button,
  Flex,
  useToast,
  Tr,
  Td,
  Select,
  Spacer,
  Tooltip,
} from '@chakra-ui/react';
import style from '../components/common/style';
import { ChecktableTwo } from '../components/common/ChecktableTwo';
import { useHistory } from 'react-router-dom';
import { options } from '../context/data';
import {
  colPages,
} from '../context/data';
import { customInputLabel } from '../components/createAppVersionComponent/createAppVersionComponent';
import { MiniHeader } from '../components/common/customComponent';
import ApiManager from '../config/apiManager';
import LangContext from '../context/languageContext';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';

const StoreManagement = () => {
  let history = useHistory();
  const [dataa, setDataa] = React.useState([]);
  const { currentLangData } = React.useContext(LangContext);
  const [valueSearch, setValueSearch] = React.useState('');
  const [value, setValue] = React.useState('10');
  const [paginat, setpaginate] = React.useState();
  const [loader, setLoader] = React.useState(false);
  const [success, setSuccess] = React.useState(null);
  let apimanager = ApiManager.getInstance();
  const toast = useToast();
  let tempArray = [];
  const handleOnChange = (evt, key) => {
    const ev = evt.target.value;
    setValue(ev);
  };
  const handleOnSearch = (evt, key) => {
    const ev = evt.target.value;
    setValueSearch(ev);
    getALLItems(value, 1);
  };
  React.useEffect(() => {
    getALLItems(value, 1);
  }, [value]);

  // value, limit, page
  const getALLItems = (limit, page) => {
    setLoader(false);
    const body = {
      searchPhrase: valueSearch,
      numRecords: limit,
      page: page,
    };
    apimanager
      .get('getPages', body)
      .then(res => {
        if (res.message === 8804) {
          res?.result?.docs?.map((value, index) => {
            tempArray.push(value);
          });
          setDataa(tempArray);
          setpaginate(res?.result);
          setLoader(true);
        }

        if (res.message === 8801) {
          toast({
            title: 'Something went wrong',
            status: 'error',
            duration: 3000,
            isClosable: true,
            description: 'Page not found',
          });
        } else if (!res.message) {
          toast({
            title: 'Something Went Wrong',
            status: 'error',
            duration: 3000,
            isClosable: true,
            description: `Something Went Wrong`,
          });
        }
      })
      .catch(error => {
        setLoader(true);
      });
  };
  const deleteItem = item => {
    let apimanager = ApiManager.getInstance();
    const body = {
      pageId: item.pageId,
    };
    apimanager
      .post('deletePage', body)
      .then(response => {
        if (response.message === 8805) {
          setSuccess('Successfully Deleted!');
          toast({
            title: success,
            status: 'success',
            duration: 3000,
            isClosable: true,
            description: `Deleted, Please processed to List!`,
          });
          getALLItems(value, 1);
        }
        if (response.message === 8801) {
          toast({
            title: 'Something went wrong',
            status: 'error',
            duration: 3000,
            isClosable: true,
            description: 'Page not found',
          });
        }
      })
      .catch(error => {});
  };
  const searchItems = (value, limit, page) => {
    setLoader(false);
    const body = {
      searchPhrase: value,
      numRecords: limit,
      page: page,
    };
    apimanager
      .post('searchStore', body)
      .then(res => {
        if (res.message === 8512) {
          res?.record?.docs.map((value, index) => {
            tempArray.push(value);
          });
          setDataa(tempArray);
          setpaginate(res?.record);
          setLoader(true);
        }
      })
      .catch(error => {
        setLoader(true);
      });
  };
  return (
    <Flex flexDirection={'column'}>
      <Flex {...style.miniheader}>
        {MiniHeader({
          title: 'Pages',
          path: 'Dashboard',
          onclickForRoute: () => history.push('/Dashboard'),
          path2: 'sidebar.Pages',
        })}
      </Flex>
      <Flex {...style.box} background={'#fafdfb'} padding={10}>
        <Flex {...style.main}>
          <Flex {...style.buttoncontainer}>
            <Button
              {...style.createbutton}
              onClick={() => history.push('/CreatePage')}
            >
              Create
            </Button>
          </Flex>
          <Flex {...style.optionFlex}>
            <Flex {...style.showentries} alignItems={'center'} fontSize={'sm'}>
              <Text>{currentLangData?.app?.show}</Text>
              <Select
                {...style.select}
                onChange={e => handleOnChange(e, 'numrecords')}
              >
                {options.map(option => (
                  <option value={option.value}>{option.label}</option>
                ))}
              </Select>
              <Text>{currentLangData?.app?.entries}</Text>
            </Flex>
            <Spacer />
            <Flex alignItems={'center'} {...style.showentries}>
              <Text paddingY={'5px'}>{currentLangData?.app?.search}:</Text>
              {customInputLabel({
                size: 'sm',
                onKeyDown: e => handleOnSearch(e, 'searchPhrase'),
              })}
            </Flex>
          </Flex>
          <ChecktableTwo
            datalist={dataa}
            TotDocs={paginat}
            loaderr={loader}
            headerNames={colPages}
            onPageChange={page => {
              if (valueSearch) {
                searchItems(valueSearch, value, page);
              } else {
                getALLItems(value, page);
              }
            }}
            renderItem={({ item, index }) => {
              let createdAt = new Date(item?.createdAt);
              let updatedAt = new Date(item?.updatedAt);
              return (
                <Tr key={index} width={'100%'}>
                  <Td>{item?.pageId}</Td>
                  <Td>{item?.pageName}</Td>
                  <Td>{createdAt.toLocaleDateString()}</Td>
                  <Td>{updatedAt.toLocaleDateString()}</Td>
                  <Td
                    position={'relative'}
                    display={'inline-flex'}
                    verticalAlign={'middle'}
                  >
                    <Tooltip label={currentLangData?.app?.edit}>
                      <Button
                        {...style.editbtn}
                        leftIcon={<EditIcon />}
                        onClick={() =>
                          history.push({
                            pathname: '/CreatePage',
                            status: 'create',
                            state: { val: item },
                          })
                        }
                      ></Button>
                    </Tooltip>
                    <Tooltip label={currentLangData?.app?.delete} bg={'red'}>
                      <Button
                        {...style.Delbtn}
                        leftIcon={<DeleteIcon />}
                        onClick={() => deleteItem(item)}
                      ></Button>
                    </Tooltip>
                  </Td>
                </Tr>
              );
            }}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
export default StoreManagement;
